import React, { useState } from "react";
import routes from "@/helpers/router";
import ArticleInfo from "@/components/ArticleInfo";
import SectionHeader from "@/components/SectionHeader";
import { fetchArticles } from "@/components/ArticleComponent/api";
import styles from "./ArticleComponent.module.scss";

const ArticleComponent = (props) => {
  const { userAgent, pillarSlug, categorySlug, clusterSlug, data, registerRef, desktopItems } = props;
  const { articles: initialArticles, Tags, Heading, ShortDescription } = data;
  const tabs = Tags?.data;

  const [activeTab, setActiveTab] = useState<string>(tabs?.[0]?.attributes?.TagName);
  const [articles, setArticles] = useState(initialArticles);

  const handleTabChange: (tab: string) => void = async (tab) => {
    try {
      const response: any = await fetchArticles({ pillarSlug, clusterSlug, categorySlug, tagName: tab });

      if (response?.length) {
        setArticles(response);
      } else {
        setArticles([]);
      }
    } catch (err) {
      setArticles([]);
      console.error(err);
    }

    setActiveTab(tab);
  };

  return (
    <>
      <section
        data-ref_id={data?.refId}
        ref={(el) => {
          if (data?.ShowHeadingInIndex && registerRef && data?.refId) registerRef(data?.refId, el);
        }}
        className={`${styles.root} scrollMargin spacingBetweenSections`}
      >
        <div className={"container"}>
          <SectionHeader userAgent={userAgent} title={Heading} subTitle={ShortDescription} />
          {!!tabs?.length && (
            <div className={styles.tabsWrapper}>
              {tabs.map(({ id, attributes }) => {
                const isActive = activeTab === attributes?.TagName;

                return (
                  <button
                    type={"button"}
                    onClick={() => handleTabChange(attributes?.TagName)}
                    key={id}
                    className={`${styles.tab} ${isActive ? styles.active : ""}`}
                  >
                    {attributes?.TagName}
                  </button>
                );
              })}
            </div>
          )}
          {/*TODO: ctaURL: ctaURL should come from parent*/}
          <ArticleInfo
            articles={articles}
            userAgent={userAgent}
            ctaURL={routes.resourcesListing("articles", categorySlug)}
            desktopItems={desktopItems}
          />
        </div>
      </section>
    </>
  );
};

export default ArticleComponent;
